<ifc-app-scroll-container class="ifc-app-scroll-container-center">
  <div id="main" fxLayout="column" fxLayoutAlign="center center">

    <form [formGroup]="form" ngClass.xs="layout fill">
      <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap.gt-xs="24px" fxLayout.xs="column" ngClass.xs="form-field-xs" ngClass.gt-xs="form-field-xl">
        <mat-form-field appearance="outline" fxFlex="48">
          <mat-label>Identity verification method</mat-label>
          <mat-select matInput formControlName="method" placeholder="Identity verification method">
            <mat-option *ngFor="let option of methodOptions" [value]="option.value">{{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="48">
          <mat-label>Verification status</mat-label>
          <mat-select matInput formControlName="status" placeholder="Verification status">
            <mat-option *ngFor="let option of statusOptions" [value]="option.value">{{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>
</ifc-app-scroll-container>
